/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'more': {
    width: 5,
    height: 23,
    viewBox: '0 0 5 23',
    data: '<path pid="0" _fill="#7b7b7b" d="M2.5 0C3.88 0 5 1.19 5 2.656c0 1.467-1.12 2.656-2.5 2.656S0 4.123 0 2.656 1.12 0 2.5 0zm0 8.844c1.38 0 2.5 1.189 2.5 2.656s-1.12 2.656-2.5 2.656S0 12.966 0 11.5c0-1.467 1.12-2.656 2.5-2.656zm0 8.843c1.38 0 2.5 1.19 2.5 2.657S3.88 23 2.5 23 0 21.81 0 20.344c0-1.467 1.12-2.657 2.5-2.657z"/>'
  }
})
